"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useCheckoutContext_1 = require("./useCheckoutContext");
var FeatureValueTypes_1 = require("../../../continueInDealership/enum/FeatureValueTypes");
exports.useBackgroundImage = function () {
    var _a = useCheckoutContext_1.default(), deal = _a.deal, loading = _a.loading;
    var _b = react_1.useState(true), isDefaultBackground = _b[0], setIsDefaultBackground = _b[1];
    var _c = react_1.useState(''), backgroundImage = _c[0], setBackgroundImage = _c[1];
    react_1.useEffect(function () {
        var _a, _b, _c, _d;
        if (deal) {
            var _e = deal.car, background = _e.background, images = _e.images;
            var isDefaultBackground_1 = background.attributes.oemcode === FeatureValueTypes_1.FeatureValueTypes.DEFAULT;
            setBackgroundImage(isDefaultBackground_1
                ? (_b = (_a = background) === null || _a === void 0 ? void 0 : _a.image[0]) === null || _b === void 0 ? void 0 : _b.url : (_d = (_c = images) === null || _c === void 0 ? void 0 : _c.find(function (image) { return image.type === FeatureValueTypes_1.FeatureValueTypes.EXTERIOR_360; })) === null || _d === void 0 ? void 0 : _d.url);
            setIsDefaultBackground(isDefaultBackground_1);
        }
    }, [deal]);
    return { backgroundImage: backgroundImage, isDefaultBackground: isDefaultBackground, loading: loading };
};
